/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function(data) {
  var defer = $.Deferred();

  $.soap({
    body: {
      GetOrganizationCRDNumberExists: {
        $xmlns: 'http://dobs.pa.gov/sc/organization/bpm/1.0',
        OrganizationID: data.organizationId,
        CRDNumber: data.crdNumber,
        ApplicantLegalName: data.applicantLegalName
      }
    },
    blueprint: {
      organizationCRDNumberExists: '$..OrganizationCRDNumberExists'
    }
  })
    .done(function(response) {
      cleanUpResponse(response, { cleanUpTextKeys: true });

      var organizationCRDNumberExists = response.organizationCRDNumberExists === '1';

      defer.resolve(organizationCRDNumberExists);
    })
    .fail(function(err) {
      defer.reject(err);
    });

  return defer.promise();
};
